import { render } from "./CreateAccession.vue?vue&type=template&id=78bd8a4e&scoped=true"
import script from "./CreateAccession.vue?vue&type=script&lang=js"
export * from "./CreateAccession.vue?vue&type=script&lang=js"

import "./CreateAccession.vue?vue&type=style&index=0&id=78bd8a4e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bd8a4e"],['__file',"src/components/orders/CreateAccession.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78bd8a4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78bd8a4e', __exports__)) {
    console.log('reload')
    api.reload('78bd8a4e', __exports__)
  }
  
  module.hot.accept("./CreateAccession.vue?vue&type=template&id=78bd8a4e&scoped=true", () => {
    console.log('re-render')
    api.rerender('78bd8a4e', render)
  })

}


export default __exports__